import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Projects } from './pages/Projects';
import { Staff } from './pages/Staff';
import { Customers } from './pages/Customers';
import { ProjectTimeline } from './pages/Timeline';
import { Finance } from './pages/Finance';
import { FinanceAnalysis } from './pages/FinanceAnalysis';
import { FinanceQuickBooks } from './pages/FinanceQuickBooks';
import { FinanceXLS } from './pages/FinanceXLS';
import { FinanceDOC } from './pages/FinanceDOC';
import { Sales } from './pages/Sales';
import { Calendar } from './pages/Calendar';
import { IP } from './pages/IP';
import { Spinoffs } from './pages/Spinoffs';
import { ShareProject } from './pages/ShareProject';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';

function App() {
  const location = useLocation();
  const isShareRoute = location.pathname.startsWith('/share');

  if (isShareRoute) {
    return (
      <Routes>
        <Route path="/share" element={<ShareProject />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/projects" replace />} />
        <Route path="projects" element={<Projects />} />
        <Route path="customers" element={<Customers />} />
        <Route path="staff" element={<Staff />} />
        <Route path="timeline" element={<ProjectTimeline />} />
        <Route path="finance" element={<Finance />} />
        <Route path="finance/analysis" element={<ProtectedRoute><FinanceAnalysis /></ProtectedRoute>} />
        <Route path="finance/quickbooks" element={<ProtectedRoute><FinanceQuickBooks /></ProtectedRoute>} />
        <Route path="finance/xls" element={<ProtectedRoute><FinanceXLS /></ProtectedRoute>} />
        <Route path="finance/doc" element={<ProtectedRoute><FinanceDOC /></ProtectedRoute>} />
        <Route path="sales" element={<Sales />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="ip" element={<IP />} />
        <Route path="spinoffs" element={<Spinoffs />} />
      </Route>
    </Routes>
  );
}

export default App